import React from "react";

import Drawer from "../components/Configurator/ui/Drawer";
import { cn } from "../lib/utils";
import Main from "../components/Configurator/scene/Main";

const Home = ({ type, currentPage }) => {
    const isTrade = type === 'trade';

    return (
        <div className={cn(
            "flex flex-col xl:flex-row overflow-hidden",
            isTrade ? "h-screen" : "h-screen lg:h-[calc(100vh-120px)]"
        )}>
            <Main />
            <Drawer type={type} />
        </div>
    );
};

export default Home;
